export default "__VITE_ASSET__BCQiM5bL__"